import { applySpec, propOr } from 'ramda';

const SKU = applySpec({
  skuId: propOr('', 'skuId'),
  skuTitle: propOr('', 'skuTitle'),
  skuType: propOr('alLaCarte', 'skuType'),
});

export default SKU;
